import { REPORT_STATUS_TINT } from "../../lib/diagnostics";

const SUB_STATUS_LABEL = {
  pending: "Pending",
  active: "Active",
  paused: "Paused",
  canceled: "Canceled",
  lapsed: "Lapsed",
};

const SUB_STATUS_TINT = {
  pending: "bg-slate-100 text-slate-700 border-slate-300",
  active: "bg-emerald-100 text-emerald-800 border-emerald-300",
  paused: "bg-amber-100 text-amber-900 border-amber-300",
  canceled: "bg-red-50 text-red-800 border-red-200",
  lapsed: "bg-rose-50 text-rose-800 border-rose-200",
};

export default function SubscriptionStatusBadge({ status }) {
  const tint =
    SUB_STATUS_TINT[status] ||
    REPORT_STATUS_TINT[status] ||
    "bg-slate-100 text-slate-700 border-slate-300";
  return (
    <span
      data-testid={`sub-status-${status}`}
      className={`inline-flex items-center rounded-md border px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide ${tint}`}
    >
      {SUB_STATUS_LABEL[status] || status}
    </span>
  );
}
